import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash2, Download } from 'lucide-react';

export const DocumentViewer = ({ document, onClose, onDelete }) => {
  const isPDF = document.file_type === 'application/pdf';
  const isImage = document.file_type?.startsWith('image/');

  const handleDownload = () => {
    try {
      const link = window.document.createElement('a');
      link.href = `data:${document.file_type};base64,${document.file_data}`;
      link.download = document.filename;
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      alert('Erro ao baixar o arquivo. Tente novamente.');
    }
  };

  const handleDelete = () => {
    if (window.confirm(`Tem certeza que deseja deletar ${document.filename}?`)) {
      onDelete(document.id);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[800px] max-h-[90vh]" data-testid="document-viewer-modal">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle data-testid="document-viewer-title">{document.filename}</DialogTitle>
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="icon"
                onClick={handleDownload}
                className="btn-transition"
                data-testid="download-document-button"
              >
                <Download className="w-4 h-4" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={handleDelete}
                className="btn-transition text-destructive hover:bg-destructive/10"
                data-testid="delete-document-button"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </DialogHeader>

        <div className="mt-4 overflow-auto max-h-[70vh]" data-testid="document-viewer-content">
          {isImage && (
            <img
              src={`data:${document.file_type};base64,${document.file_data}`}
              alt={document.filename}
              className="document-preview w-full"
              data-testid="document-image"
            />
          )}
          {isPDF && (
            <iframe
              src={`data:${document.file_type};base64,${document.file_data}`}
              className="w-full h-[600px] border border-border rounded-lg"
              title={document.filename}
              data-testid="document-pdf"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentViewer;